var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-tabular__container"},[_c('div',{class:[
      'dp-tabular__row',
      {
        'dp-tabular__row--padded': !_vm.hasScroll,
      } ],style:({
      'width': (_vm.maxWidth + "px"),
    })},_vm._l((_vm.columns),function(column,i){return _c('div',{key:column.name,ref:column.name,refInFor:true,staticClass:"dp-tabular__cell",style:(_vm.getColumnWidth(column))},[_c('div',{staticClass:"dp-tabular__cell-content",style:({
          'padding-left': i === 0 && ("calc(1em * " + _vm.level + " + 5px)"),
        })},[_vm._v(" "+_vm._s(_vm.getDisplayValue(column, _vm.value[column.name]))+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }